import logoImage from '@/assets/logo.png';
import { Link } from 'react-router-dom';

export default function MarketingFooter() {
  return (
    <footer className="py-8 border-t mt-16">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex flex-col gap-6 sm:gap-4">
          {/* Logo and links row */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2">
              <img src={logoImage} alt="IMRACK Logo" className="h-6 w-6 rounded object-contain" />
              <span className="text-sm font-medium text-foreground">IMRACK®</span>
            </Link>
            
            {/* Navigation links - wrap on mobile */}
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs text-muted-foreground">
              <Link to="/features" className="hover:text-foreground transition-colors">Features</Link>
              <Link to="/resources" className="hover:text-foreground transition-colors">Resources</Link>
              <Link to="/faq" className="hover:text-foreground transition-colors">FAQ</Link>
              <Link to="/glossary" className="hover:text-foreground transition-colors">Glossary</Link>
              <Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link>
            </div>
          </div>
          
          {/* Copyright - centered on mobile */}
          <p className="text-xs text-muted-foreground text-center sm:text-right">
            © {new Date().getFullYear()} IMRACK®. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}